import { GetResponseInterface } from "../../interfaces/ActionReducer/GetMethod/GetResponse";

export const GET_USER_CLASS_TYPE = "GET_USER_CLASS_TYPE";
export const USER_CLASS_TYPE_RECEIVED = "USER_CLASS_TYPE_RECEIVED";
export const GET_DISPLAY_NAME_MAPPING = "GET_DISPLAY_NAME_MAPPING";
export const IS_LOGIN_SUCCESSFUL = "IS_LOGIN_SUCCESSFUL";

export const DISPLAY_NAME_MAPPING_RECEIVED = "DISPLAY_NAME_MAPPING_RECEIVED";

export interface GetUserClassTypeInterface {
    fields: string;
    [propName: string]: string | number | boolean;
}

export interface Bounds {
    _ne: {
        lat: number;
        lng: number;
    };
    _sw: {
        lat: number;
        lng: number;
    };
}

export interface GetAllUserClassTypeAction {
    type: typeof GET_USER_CLASS_TYPE;
    payload: { params: GetUserClassTypeInterface };
}
export type GetAllUserClassType = GetUserClassTypeInterface;

export type UserClassTypeReceived = { [prop: string]: object };

export interface AllUserClassTypeReceivedAction {
    type: typeof USER_CLASS_TYPE_RECEIVED;
    payload: { allUserClassTypeReceived: UserClassTypeReceived };
}

export type AllUserClassTypeReceived = UserClassTypeReceived;

export interface GetDisplaynameMappingAction {
    type: typeof GET_DISPLAY_NAME_MAPPING;
    payload: { params: GetUserClassTypeInterface };
}

export type GetDisplayNameMappingType = GetUserClassTypeInterface;

export interface SubRestrictionRecord {
    activity: string;
    color: string;
    dash_style: string;
    display_name: string;
    filter_section: string;
    reason: string;
    userclasscategory: number;
    id: number;
    priority?: number;
}

export interface DisplayNameMappingReceived extends GetResponseInterface {
    results: Array<SubRestrictionRecord>;
}

export interface DisplayNameMappingReceivedAction {
    type: typeof DISPLAY_NAME_MAPPING_RECEIVED;
    payload: { displayNameMappingReceived: DisplayNameMappingReceived };
}

export interface PublicViewerState {
    allUserClassType: AllUserClassTypeReceived;
    displayNameMappingType: DisplayNameMappingReceived;
    isDisplayNameMappingFetched: boolean;
}

export type PublicViewerTypes =
    | GetAllUserClassTypeAction
    | AllUserClassTypeReceivedAction
    | GetDisplaynameMappingAction
    | DisplayNameMappingReceivedAction;
